import request from '@/utils/request'
export function setCode(data){
  return request({
    url: '/offline_auth/set_code/',
    method:'POST',
    data
  })
}

export function getLicense(data){
  return request({
    url: '/offline_auth/get_license/',
    method:'POST',
    data
  })
}


export function getModuleOfflineList(param) {
  return request({
      url: `/offline_auth/${param}`,
      method: 'GET'
  })
}




// WEBPACK FOOTER //
// ./src/api/offlineAuth.js